export default __webpack_public_path__ + "static/media/paperFoldedSmall.1bd898f7.jpg";